export const actionTypes = {
  SET_CURGROUP: "SET_CURGROUP",
  SET_GROUPLIST: "SET_GROUPLIST",
  SET_MESSAGE: "SET_MESSAGE",
  SET_PRIVILEGELIST: "SET_PRIVILEGELIST",
  SET_MANAGERLIST: "SET_MANAGERLIST",
  SET_JOB_PRIVILEGE: "SET_JOB_PRIVILEGE",
  SET_MANAGERLIST_STR_ID: "SET_MANAGERLIST_STR_ID",
};